// extracted by mini-css-extract-plugin
export default {"root":"NR6gC6","errorNotification":"eu0g4Y"};